// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__36DAf","approved":"Status_approved__23Plc","rejected":"Status_rejected__Io5zK","expired":"Status_expired__3nbeX","label":"Status_label__wzbIm"};